module.exports = __webpack_public_path__ + "static/media/galerija_2021 (34)-min.9cb1476b.jpg";